/**
 * Mirrors backend MachineCloneStatusEnum (app/engines/demo_account/tasks.py).
 * Canonical machine-clone statuses emitted by demo account and hierarchy clone tasks.
 */
export const MachineCloneStatusEnum = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  SKIPPED: 'skipped',
};

const STATUS_ALIASES = {
  success: MachineCloneStatusEnum.COMPLETED,
  failure: MachineCloneStatusEnum.FAILED,
};

export const MACHINE_CLONE_FINAL_STATUSES = [
  MachineCloneStatusEnum.COMPLETED,
  MachineCloneStatusEnum.FAILED,
  MachineCloneStatusEnum.SKIPPED,
];

export const normalizeMachineCloneStatus = (status) => {
  const normalized = String(status || MachineCloneStatusEnum.PENDING).toLowerCase();
  return STATUS_ALIASES[normalized] || normalized;
};

export const isMachineCloneFinalStatus = status => (
  MACHINE_CLONE_FINAL_STATUSES.includes(normalizeMachineCloneStatus(status))
);

export const isMachineCloneSuccessStatus = status => (
  normalizeMachineCloneStatus(status) === MachineCloneStatusEnum.COMPLETED
);

export const isMachineCloneFailureStatus = status => (
  normalizeMachineCloneStatus(status) === MachineCloneStatusEnum.FAILED
);
